import ModalWrapper from '../../components/modals/ModalWrapper';
import LoginForm from './LoginForm';
import OtpForm from './OtpForm';
import Captcha from '../../../../components-library/auth/turnstile/Captcha';
import useOtpFlow from './useOtpFlow';
import { IModal } from '../../router/ModalRouter';
import { Modals } from '../../exports/Enums';
import ModalHeader from '../../components/modals/ModalHeader';
import Button from '../../components/buttons/Button';
import { FC, ReactElement } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import useCashbackProgram from '../../../../hooks/cashback/useCashbackProgram';

const LoginModal: FC<Partial<IModal>> = ({ closeModal, openModal }) => {
  const { hasTurnstile, otpResult, send, resend, loading, attachToken, lastSentChannel, retryAfter } = useOtpFlow();
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Modals:Login:LoginModal' });
  const { cashbackProgram } = useCashbackProgram();
  const hasOtpForm = otpResult.isSuccess;

  const SignUp: FC<{ className?: string }> = ({ className }): ReactElement => {
    return (
      <div className={classnames('flex items-center justify-center w-full', className)}>
        <p className="!text-muted-foreground">{t('labels.dont_have_account')}</p>
        <Button
          title={t('buttons.sign_up')}
          slot="end"
          design="link"
          onClick={() => openModal({ id: Modals.Signup })}
          className="ml-[3px]"
        />
      </div>
    );
  };

  return (
    <>
      <ModalWrapper className={'h-[80dvh]'}>
        <ModalHeader
          title={t('title', { name: cashbackProgram?.title ?? t('default_program_name') })}
          onClose={closeModal}
        />
        <div className="pt-md space-y-md px-sm">
          {hasOtpForm ? (
            <OtpForm
              onSuccess={closeModal}
              defaultValues={otpResult.data}
              onResendClick={resend}
              sentChannel={lastSentChannel}
              deliveryAddress={otpResult.data?.delivery_address}
              resending={loading}
              retryAfter={retryAfter}
              hasTurnstile={hasTurnstile}
              attachToken={attachToken}
            />
          ) : (
            <LoginForm onSubmit={send} loading={loading}>
              {hasTurnstile && !hasOtpForm && <Captcha className="text-center" onVerify={attachToken} />}
            </LoginForm>
          )}
        </div>
        {!hasOtpForm && <SignUp className="mt-sm" />}
      </ModalWrapper>
    </>
  );
};

export default LoginModal;
